import { Separator, Skeleton } from "@/components/ui";
import { Fragment } from "react";

export const LabsSkeleton = () => {
  return (
    <div
      className="flex flex-col gap-2 rounded transition-colors mt-1 px-3 py-2"
      data-testid="labs-skeleton"
    >
      {[...Array(5)].map((_, index) => (
        //  biome-ignore lint/suspicious/noArrayIndexKey: unneeded for loading skeleton
        <Fragment key={`labs-skeleton-${index}`}>
          <div className="flex flex-row gap-4">
            <Skeleton className="h-12 w-1/2" />
            <Skeleton className="h-12 w-1/2" />
          </div>
          <Separator />
        </Fragment>
      ))}
    </div>
  );
};
